// BirthPlaceHint — the inline line under a birth-place input.
import React from 'react';
import { PICK_FROM_LIST_MESSAGE, NEAREST_TOWN_MESSAGE, CHECK_FAILED_MESSAGE } from '../utils/birthPlace';

export const birthPlaceHintText = ({ status, place, matchedName }) => {
  if (!(place || '').trim()) return null;
  if (status === 'resolving') return { tone: 'muted', text: 'Checking this place…' };
  if (status === 'resolved') return { tone: 'ok', text: `Found: ${matchedName || place}` };
  if (status === 'check_failed') return { tone: 'error', text: CHECK_FAILED_MESSAGE, retry: true };
  if (status === 'unresolved') return { tone: 'error', text: `${PICK_FROM_LIST_MESSAGE}. ${NEAREST_TOWN_MESSAGE}` };
  if (status === 'typed') return { tone: 'error', text: PICK_FROM_LIST_MESSAGE };
  return null;
};

const TONE_COLOR = { muted: 'rgba(255,255,255,0.55)', ok: '#86efac', error: '#fca5a5' };

export default function BirthPlaceHint(props) {
  const hint = birthPlaceHintText(props);
  if (!hint) return null;
  if (hint.retry && props.onRetry) {
    return (
      <button
        type="button"
        onClick={props.onRetry}
        data-testid="birth-place-hint"
        style={{ color: TONE_COLOR.error, fontSize: 13, marginTop: 6, background: 'none', border: 'none', padding: 0, textDecoration: 'underline', cursor: 'pointer' }}
      >
        {hint.text}
      </button>
    );
  }
  return (
    <p
      role={hint.tone === 'error' ? 'alert' : undefined}
      data-testid="birth-place-hint"
      style={{ color: TONE_COLOR[hint.tone], fontSize: 13, marginTop: 6 }}
    >
      {hint.text}
    </p>
  );
}
